import { useGobblerMetadataFromPublicNftEndpoint } from 'hooks/gobblers/useGobblerMetadata'
import Link from 'next/link'
import styled from 'styled-components'
import { calculateGooProductionRate } from 'utils/emissions'
import { GobblerTableProps } from './GobblerTable'
import { getCleanNumber } from './GooEquation'

const GobblerTableContainer = styled.div`
  width: calc(100% - 40px);
  margin-top: 32px;
`
const GobblerRowContainer = styled.div`
  display: block;
  background-image: url('/images/factory/gobbler_mobile_row.png');
  background-size: 100% 100%;
  width: 100%;
  background-position: center;
  font-weight: 500;

  padding: 16px 36px;
  padding-top: 4px;
`

const GobblerNameCell = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0;
`

const GobblerImage = styled.img`
  border-radius: 16px;
  height: 32px;
  width: 32px;
  margin-right: 12px;
`

const GobblerName = styled.div`
  font-weight: 700;
  font-size: 18px;
`

const GobblerDetailsCell = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
`

function GobblerRow({
  gobblerId,
  virtualGooBalanceForUser,
}: // name,
// imageUrl,
// totalGooCreated,
// gooStaked,
// multiplier,
// dailyProduction,
{
  gobblerId: string
  virtualGooBalanceForUser: number | undefined
  // name: string
  // imageUrl: string
  // totalGooCreated: number
  // gooStaked: number
  // multiplier: number
  // dailyProduction: number
}) {
  const gobblerMetadata = useGobblerMetadataFromPublicNftEndpoint(gobblerId)
  const productionRate = calculateGooProductionRate(
    virtualGooBalanceForUser ?? 0,
    gobblerMetadata.multiplier ?? 0,
  )

  const formattedProductionRate = getCleanNumber(productionRate)

  const isRevealed = !!gobblerMetadata.revealed

  return (
    <Link
      href={{
        pathname: '/gobbler/[gobblerId]',
        query: {
          gobblerId: gobblerId,
        },
      }}
      passHref={true}
    >
      <GobblerRowContainer as={'a'} style={{ marginBottom: 16 }}>
        <GobblerNameCell>
          <GobblerImage alt="Gobbler" src={gobblerMetadata.image} />
          <GobblerName>{isRevealed ? gobblerMetadata.name : 'Unrevealed'}</GobblerName>
        </GobblerNameCell>
        <GobblerDetailsCell>
          {/* <div>{totalGooCreated}</div> */}
          {/* <div>{gooStaked}</div> */}
          <div>{isRevealed ? `${gobblerMetadata.multiplier}x` : '??'}</div>
          <div>{isRevealed ? formattedProductionRate : '??'} G/d</div>
        </GobblerDetailsCell>
      </GobblerRowContainer>
    </Link>
  )
}

const GobblerMobileTable: React.FC<GobblerTableProps> = (props) => {
  const gobblerIds = props.gobblerIdsOwned ?? []
  return (
    <GobblerTableContainer>
      {gobblerIds.map((gId) => {
        return (
          <GobblerRow
            key={gId}
            virtualGooBalanceForUser={props.virtualGooBalanceForUser}
            gobblerId={gId.toString()}
          />
        )
      })}
    </GobblerTableContainer>
  )
}

export default GobblerMobileTable
export { GobblerMobileTable }
